// 1. Import the utilities
import { createBreakpoints } from '@chakra-ui/theme-tools'
// 2. Update the breakpoints as key-value pairs
export const breakpoints = createBreakpoints({
  xs: '480px',
  sm: '768px',
  md: '960px',
  lg: '1024px',
  xl: '1400px'
})
